import { Api } from './api/Api'

export function apiGetFreightages(params) {
  return Api('get', '/freightage/get_freightages', { params });
}
